var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-menu'),_c('div',{staticClass:"gray-spacing"}),_c('div',{staticClass:"app-view"},[_c('router-view',{staticClass:"route-view",style:({width: _vm.width})}),_c('div',{staticClass:"gray-spacing"})],1),_c('rodape')],1)}
var staticRenderFns = []

export { render, staticRenderFns }